module.exports = __webpack_public_path__ + "img/GAME_HORSE.fb957604.jpg";